import React, {
  FC, useEffect, useRef,
} from 'react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';
import OptionButton from '../components/Button/OptionButton';
import UserReply from '../components/Reply/UserReply';
import Q17 from '../Q17';
import Q19 from '../Q19';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import CheckLoading from '../components/Loading/CheckLoading';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import RobotLoading from '../components/Loading/RobotLoading';
import OpenLockFail from '../OpenLockFail';

/**
 * 逐个开柜门
 */
const Q16: FC<Props> = ({
  cabId,
  boxList,
  addElement,
  setTargetPage,
  deviceCode,
  h5Platform,
  loadingFlowId,
  needOpenLock,
  sessionId,
  enterPhoneNumber,
}) => {
  const option1 = { zhValue: '是的，这是我的外卖订单', enValue: 'Yes, this is my food' };
  const option2 = { zhValue: '不是，这不是我的外卖订单', enValue: 'No, this is not my food' };
  const hasUpdateOrder = useRef<boolean>(false);

  // 检查柜子是否在线
  const [getCabOnline] = getFoodifoxDataLazy<boolean>('/fox3PDAi/cabOnlineStatus?cabId=' + boxList[0].cabId);
  const [openLock] = updateFoodifoxData('/fox3PDAi/boxOpenLock');
  const [getLockerStatus] = getFoodifoxDataLazy<boolean>('/fox3PDAi/boxStatus');
  // 更新订单
  const [updateOrder] = updateFoodifoxData('/fox3PDAi/updateOrder');

  /**
   * 隐藏loading
   */
  const hideLoading = () => {
    if (loadingFlowId) {
      // 隐藏loading
      TempFieldUtils.aiFlowIds.push(loadingFlowId);
      TempFieldUtils.aiFlowIds.push(...TempFieldUtils.aiRetainLoadingIds);
      TempFieldUtils.aiRetainLoadingIds = [];
    }
  };

  /**
   * 检测柜门有没有关闭
   * @param loadingFlowId
   */
  const checkLockerStatus = (loadingFlowId: string) => {
    const box = boxList[0];
    getLockerStatus({
      param: {
        ...box,
      },
      onCompleted(isOpen) {
        if (!isOpen) {
          const boxes = boxList.slice(1);
          if (boxes.length > 0) {
            addElement(
              <Q16
                cabId={box.cabId}
                boxList={boxes}
                addElement={addElement}
                setTargetPage={setTargetPage}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                loadingFlowId={loadingFlowId}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
          else {
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
            addElement(
              <Q19
                cabId={box.cabId}
                addElement={addElement}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                sessionId={sessionId}
              />
            );
          }
        }
        else {
          setTimeout(() => {
            checkLockerStatus(loadingFlowId);
          }, 3000);
        }
      },
    });
  };

  /**
   * 检查柜子是否在线
   * @param box
   */
  const checkCabOnline = (box: { cabId: number; boxNumber: string }) => {
    getCabOnline({
      onError() {
        setTimeout(() => {
          checkCabOnline(box);
        }, 3000);
      },
      onCompleted(isOnline) {
        if (!isOnline) {
          setTimeout(() => {
            checkCabOnline(box);
          }, 3000);
          return;
        }

        openLock({
          param: {
            ...box,
          },
          onCompleted(status) {
            // 隐藏loading
            hideLoading();
            if (status) {
              initPage();
            }
            else {
              addSystemLog(box.cabId, deviceCode, h5Platform + '', 'Q16 - 柜子：' + box.cabId + '，柜门：' + box.boxNumber + '开锁失败', sessionId);
              addElement(
                <OpenLockFail
                  cabId={box.cabId}
                  addElement={addElement}
                  deviceCode={deviceCode}
                  h5Platform={h5Platform}
                  qStep={16}
                  openBoxList={[box]}
                  boxList={boxList}
                  setTargetPage={setTargetPage}
                  sessionId={sessionId}
                  enterPhoneNumber={enterPhoneNumber}
                />
              );
            }
          },
        });
      }
    });
  };

  /**
   * 更新订单为已完成
   * @param flowId
   */
  const updateOrderCompleted = (flowId?: string) => {
    const box = boxList[0];
    updateOrder({
      param: {
        boxNumberCabList: [{ ...box, deviceCode, sessionId }],
      },
      onCompleted() {
        if (flowId) {
          setTimeout(() => {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(flowId);
          }, 2000);
          setTimeout(() => {
            addElement(
              <Q17
                addElement={addElement}
                setTargetPage={setTargetPage}
                cabId={box.cabId}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }, 2200);
        }
        else {
          addElement(
            <Q17
              addElement={addElement}
              setTargetPage={setTargetPage}
              cabId={box.cabId}
              h5Platform={h5Platform}
              deviceCode={deviceCode}
              sessionId={sessionId}
              enterPhoneNumber={enterPhoneNumber}
            />
          );
        }
      },
    });
  };

  /**
   * 进来页面时自动打开有订单的第一个柜门
   */
  useEffect(() => {
    if (boxList.length > 0 && (needOpenLock == null || needOpenLock)) {
      const box = boxList[0];
      checkCabOnline(box);
    }
    else {
      // 隐藏loading
      hideLoading();
      initPage();
    }

    return () => {
      addSystemLog(boxList[0].cabId, deviceCode, h5Platform + '', 'Q16 - user: Quit');
      if (!hasUpdateOrder.current) {
        updateOrderCompleted();
        addSystemLog(boxList[0].cabId, deviceCode, h5Platform + '', 'Q16 - 退出会话时，更新订单为已完成，boxNumber: ' + boxList[0].boxNumber, sessionId);
      }
    };
  }, []);

  const initPage = () => {
    // 流程ID
    const flowId = uuid();
    const langZh = '我为您找到了该时间段的其他订单，现在正在为您打开下一个柜门。请检查并确 定柜内是不是您的外卖订单。如果这不是您的订单，请不要取走食物并且将柜门 关闭。';
    const langEn = 'I have found another order that matches your delivery time, I will open another door for you. Please check and confirm whether this is your order. If not, please do not remove the food and please close the door.';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center' }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q16 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option1.zhValue}
              langEn={option1.enValue}
              flowId={flowId}
              callback={() => {
                addSystemLog(boxList[0].cabId, deviceCode, h5Platform + '', 'Q16 - user: ' + option1.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option1.zhValue}
                    langEn={option1.enValue}
                  />
                );
                const loadingFlowId = uuid();
                addElement(
                  <RowLeft>
                    <RobotLoading flowId={loadingFlowId} />
                  </RowLeft>
                );
                // 更新订单为已完成
                hasUpdateOrder.current = true;
                updateOrderCompleted(loadingFlowId);
              }}
            />
          </RowLeft>
          <RowLeft>
            <OptionButton
              langZh={option2.zhValue}
              langEn={option2.enValue}
              flowId={flowId}
              callback={() => {
                // 标识订单为已完成，退出页面时就不会再次更新订单
                hasUpdateOrder.current = true;
                addSystemLog(boxList[0].cabId, deviceCode, h5Platform + '', 'Q16 - user: ' + option2.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option2.zhValue}
                    langEn={option2.enValue}
                  />
                );

                // 流程ID
                const flowId = uuid();
                const langZh = '请您关上此柜门，在您关上柜门后我们会为您开启下一个柜门查看食物。';
                const langEn = 'Please close the locker door, I will only open the next door if I detect the door is closed and food is still inside.';
                setTimeout(() => {
                  addElement(
                    <LeftToRight flowId={flowId}>
                      <RowLeft style={{ alignItems: 'center' }}>
                        <RobotReply
                          style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.58) }}
                          langZh={langZh}
                          langEn={langEn}
                        />
                      </RowLeft>
                    </LeftToRight>
                  );
                }, 500);

                // 机器人回复日志
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q16 - bot: ' + langEn, sessionId);

                setTimeout(() => {
                  const loadingFlowId = uuid();
                  addElement(
                    <CheckLoading
                      flowId={loadingFlowId}
                      zhText={
                        <>
                          请稍等<span style={{ fontFamily: 'Squad-Regular, Squad' }}>…</span>正在检查柜内食物和柜门关闭状态<span style={{ fontFamily: 'Squad-Regular, Squad' }}>…</span>
                        </>
                      }
                      enText={'Please wait…We are checking if the door is close and food still inside.'}
                      style={{ maxWidth: lang('80%', '100%') }}
                    />
                  );
                  checkLockerStatus(loadingFlowId);
                }, 1000);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  };

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  boxList: { cabId: number; boxNumber: string; boxId: number }[];
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  deviceCode: string;
  h5Platform: number;
  loadingFlowId?: string;
  needOpenLock?: boolean;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q16;
